enum CreditType {
    DEFAULT = 0,
    EXODO = 1,
    KEFALAIO = 2,
    TOKOI_TOKWN = 4,
}

export default CreditType;